import type React from 'react';
import { twMerge } from 'tailwind-merge';

import Button from 'components/partials/button/button';

import MessageInfoItem from './message-info-item';

import { AI_ASSISTANT_CHAT_MESSAGE_MAX_WIDTH_CLASS } from '../../ai-assistant.constants';

import Icons from 'assets/icons';

interface MessageErrorItemProps {
  message: { content?: string };
  onRetry: () => void;
  isLimit?: boolean;
  isRetryDisabled?: boolean;
}

const MessageErrorItem = ({
  message,
  onRetry,
  isLimit = false,
  isRetryDisabled = false,
}: MessageErrorItemProps): React.JSX.Element => {
  if (isLimit) {
    return (
      <MessageInfoItem
        message={message.content ?? ''}
        className={twMerge('mb-5', AI_ASSISTANT_CHAT_MESSAGE_MAX_WIDTH_CLASS)}
      />
    );
  }

  return (
    <div
      className={twMerge(
        'flex justify-between items-center gap-3 w-fit bg-critical-50 px-4 py-3 rounded-md border border-critical-600 mb-5',
        AI_ASSISTANT_CHAT_MESSAGE_MAX_WIDTH_CLASS
      )}
    >
      <p className="text-critical-800">{message.content}</p>

      <Button
        size="sm"
        variant="reserve-outlined"
        className="text-critical-600 bg-white border-critical-600 !h-7"
        iconBefore={<Icons.Retry />}
        onClick={onRetry}
        disabled={isRetryDisabled}
      >
        Retry
      </Button>
    </div>
  );
};

export default MessageErrorItem;
